import OrderAddressSearchComponent from "../order/OrderAddressSearchComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";
import {useState} from "react";
import ConditionsSpecificAddressComponent from "../broadband/ConditionsSpecificAddressComponent.tsx";
import TrustLineComponent from "../trustpilot/trustLineComponent.tsx";

const preDefault = 'fra'
const defaultPrice = 299
const time = '6 mdr.'
const campaignPrice = 99
const min6 = (6 * campaignPrice)

export default function MVFP2025HeroComponent() {
    const [showPopUp, setShowPopup] = useState<boolean>(false);

    return (
        <div id="hero-container" className="hero-container hero-container--mvfp-2025 hero-container--gradient darkteal">
            <div className="hero-background-wrapper">
                <div className="hero-background"/>
            </div>

            <div className="hero-content">
                <h1>
                    <span className="hero-pre-price">
                        <strong>Få 1000 Mbit</strong><br/>
                        fibernet til kun
                    </span>
                    <span className={`hero-price${campaignPrice < 100 ? ' hero-price--99' : ''}`}>
                        <span className="price">{campaignPrice}</span>
                        <span className="price-comma-dash">,-</span>
                        <span className="price-md price-md-right">/md.</span>
                    </span>
                    <span className="hero-post-price">
                        i {time}<br/>
                        Herefter fra <strong>{defaultPrice},-/md.</strong>
                    </span>
                </h1>

                <div className="stamp-container">
                    <img
                        src={imageMap.home.mvfp_2025}
                        alt="Hiper er vinder af Mest Værdi for Pengene for 2025 blandt internetudbydere. Køb dit internet hos Hiper nu."
                    />
                    <p>
                        For sjette år i&nbsp;<u>træk</u>
                    </p>
                </div>
            </div>

            <div className="address-wrap">
                <h2>
                    Se hvilket tilbud du kan få
                    <span className="scroll-down-arrow"/>
                </h2>
                <OrderAddressSearchComponent/>
            </div>

            <TrustLineComponent/>

            <p className="conditions">
                Kampagnetilbuddet er et eksempel, og gælder fiber på{' '}
                <button className={'link'} onClick={() => setShowPopup(true)}>udvalgte adresser</button>.{' '}
                Inkl. gratis oprettelse og wifi-router.
                Min. pris i 6 mdr. fra {min6} kr.
                Pris efter {time} {preDefault} {defaultPrice} kr./md.
                Forudsætter at du ikke har været kunde de seneste 6 mdr.
            </p>

            <ConditionsSpecificAddressComponent show={showPopUp} setShow={setShowPopup}/>
        </div>
    )
}
